import React from 'react';
import {X1Language} from '../../../domain';
import {TooltipBreadcrumb} from '../../../lib/components';
import {routes} from '../../../pages/Routes';

export class X1LanguageBreadcrumbs extends React.Component<{ language: X1Language }> {
  render() {
    const {language} = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="breadcrumb">
            <TooltipBreadcrumb tooltip="Languages"
                               label="Languages"
                               route={routes.X1LanguageList}/>

            <TooltipBreadcrumb tooltip="Language"
                               label={language.Name}
                               active/>
          </div>
        </div>
      </div>
    );
  }
}
